import { render, staticRenderFns } from "./manualMonitoring2Form.vue?vue&type=template&id=13a415f7"
import script from "./manualMonitoring2Form.vue?vue&type=script&lang=js"
export * from "./manualMonitoring2Form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports